export default __webpack_public_path__ + "static/media/laconic_mobile_small.225416a0.jpg";